import React from 'react';

const Checkbox = ({ id, label, value, onClick, checked, disabled }) => {
  return (
    <div className="flex items-center">
      <input
        id={id}
        type="checkbox"
        value={value}
        onChange={onClick}
        checked={checked}
        disabled={disabled}
        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded"
      />
      <label htmlFor={id} className="ml-2 text-sm text-gray-900">
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
